import ConfigIcon from '@clearkit/icons/glyphs/Config';
import FormsIcon from '@clearkit/icons/glyphs/Forms';
import { CKTab, CKTabList, CKTabs } from 'clearkit';
import { useHistory } from 'react-router-dom';

import ConnectorLayout from '~/components/layouts/ConnectorLayout';
import Tile from '~/images/Tiles/Forms.svg';
import { configurationNameForType } from '~/lib/configuration';
import paths from '~/lib/paths';
import { connectorLocations } from '~/lib/segmentAnalytics';

import Configuration from './Configuration';
import Mappings from './Mappings';

const TABS = [
  {
    key: 'configuration',
    title: 'Configuration',
    icon: ConfigIcon,
    component: Configuration,
    index: 0,
  },
  {
    key: 'mappings',
    title: 'Form Field Mappings',
    icon: FormsIcon,
    component: Mappings,
    index: 1,
  },
];

function FormConfiguration({ integration, selectedTab }) {
  const currentTab = selectedTab || 'configuration';

  const currentTabObject = TABS.find((t) => t.key === currentTab);
  const FormComponent = currentTabObject.component;
  const history = useHistory();

  return (
    <ConnectorLayout
      integration={integration}
      connectorLocation={connectorLocations.forms}
      subtitle={`Improve conversion rates on ${configurationNameForType(
        integration,
      )} forms`}
      breadcrumb={[
        {
          title: 'Forms',
          path: paths.forms(),
        },
      ]}
      tile={<Tile />}
      tabs={
        <CKTabs
          className="h-full"
          index={currentTabObject.index}
          onChange={(index) => {
            const newTab = TABS[index];

            history.push(`/forms/${integration}/${newTab.key}`);
          }}
          isBordered>
          <CKTabList aria-label="Forms Configuration Tabs">
            {Object.values(TABS).map((tab) => (
              <CKTab key={tab.key} icon={<tab.icon />} label={tab.title}>
                {tab.title}
              </CKTab>
            ))}
          </CKTabList>
        </CKTabs>
      }>
      {() => (
        <div className="h-full px-10 py-10 bg-gray-50">
          <FormComponent integration={integration} />
        </div>
      )}
    </ConnectorLayout>
  );
}

export default FormConfiguration;
